// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-panel[data-v-53e0d67d] {
  display: flex;
  flex-direction: column;
  gap: 32px;
}
.add-panel__actions[data-v-53e0d67d] {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 24px;
}`, "",{"version":3,"sources":["webpack://./src/assets/js/components/panels/AddPanel.vue","webpack://./AddPanel.vue"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;ACDF;ADGE;EACE,aAAA;EACA,SAAA;EACA,yBAAA;EACA,gBAAA;ACDJ","sourcesContent":["@import \"./src/assets/sass/_vars.scss\";\n\n.add-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n\n  &__actions {\n    display: flex;\n    gap: 12px;\n    justify-content: flex-end;\n    margin-top: 24px;\n  }\n}\n",".add-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n}\n.add-panel__actions {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n  margin-top: 24px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
